'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./DocumentModeCanvasReadingLineDebugger.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var getLineStyle = function getLineStyle(_ref) {
    var top = _ref.top,
        left = _ref.left,
        gridSize = _ref.gridSize;
    return {
        top: top * gridSize,
        left: left * gridSize
    };
};

// Styles


var DocumentModeCanvasReadingLineDebugger = function DocumentModeCanvasReadingLineDebugger(props) {
    var className = props.className,
        order = props.order,
        start = props.start,
        end = props.end,
        gridSize = props.gridSize;


    var width = Math.abs(end.x - start.x) * gridSize;
    var height = Math.max(2, Math.abs(end.y - start.y)) * gridSize + 10;

    var top = Math.min(start.y, end.y) - 1;
    var left = Math.min(start.x, end.x);

    var x1 = (start.x - left) * gridSize;
    var x2 = (end.x - left) * gridSize;

    var y1 = (start.y - top) * gridSize;
    var y2 = (end.y - top) * gridSize;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('DocumentModeCanvasReadingLineDebugger', className),
            style: getLineStyle({ top: top, left: left, gridSize: gridSize }) },
        _react2.default.createElement(
            'div',
            { className: 'order-marker' },
            _react2.default.createElement(
                'span',
                { className: 'text' },
                order
            )
        ),
        _react2.default.createElement(
            'svg',
            { className: 'line', version: '1.1', width: width, height: height },
            _react2.default.createElement(
                'defs',
                null,
                _react2.default.createElement(
                    'marker',
                    { id: 'arrow', className: 'arrow', markerWidth: '5', markerHeight: '5', refX: '5', refY: '2',
                        orient: 'auto', markerUnits: 'strokeWidth' },
                    _react2.default.createElement('path', { d: 'M0,0 L0,4 L6,2 z' })
                )
            ),
            _react2.default.createElement('line', { x1: x1, x2: x2, y1: y1, y2: y2, fill: 'transparent', markerEnd: 'url(#arrow)' })
        )
    );
};

DocumentModeCanvasReadingLineDebugger.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    order: _propTypes2.default.number.isRequired,
    start: _propTypes2.default.object.isRequired,
    end: _propTypes2.default.object.isRequired,
    className: _propTypes2.default.string
};

exports.default = DocumentModeCanvasReadingLineDebugger;


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeCanvasReadingLineDebugger.js
// module id = 447
// module chunks = 0